/**
 * 郵便番号の検証
 * @param {string} zipcode 郵便番号
 * @returns {boolean}
 */
export const isValidZipcode = (zipcode) => {
    if (!zipcode) return false;
    // ハイフンを除去して7桁の数字かチェック
    const cleanZip = zipcode.replace(/-/g, "");
    return /^\d{7}$/.test(cleanZip);
};

/**
 * 数値の検証
 * @param {string|number} value 値
 * @param {number} min 最小値
 * @returns {boolean}
 */
export const isValidNumber = (value, min = 0) => {
    if (!value && value !== 0) return false;
    const num = parseFloat(value);
    return !isNaN(num) && num >= min;
};
